import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "~/components/ui/breadcrumb";
import useNextGenHeader from "~/contexts/nextgen-header";
import { cn } from "~/lib/utils";

export function ManifoldNextGenAppHeader() {
  const { breadcrumbs, title, actions, rightPane } = useNextGenHeader();
  const navigate = useNavigate();

  // Breadcrumb fills (1fr); title, actions, and optional rightPane size to content.
  const gridCols = rightPane ? "grid-cols-[1fr_auto_auto_auto]" : "grid-cols-[1fr_auto_auto]";

  return (
    <div className={cn("grid shrink-0 items-stretch border-b border-border", gridCols)}>
      <div className="flex items-center py-3 pl-4">
        {breadcrumbs.length > 0 ? (
          <Breadcrumb>
            <BreadcrumbList>
              {breadcrumbs.map((crumb, index) => {
                const isLast = index === breadcrumbs.length - 1;
                return (
                  <Fragment key={index}>
                    <BreadcrumbItem>
                      {isLast || !crumb.href ? (
                        <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink
                          href={crumb.href}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(crumb.href!);
                          }}
                        >
                          {crumb.label}
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!isLast && <BreadcrumbSeparator />}
                  </Fragment>
                );
              })}
            </BreadcrumbList>
          </Breadcrumb>
        ) : (
          title && <span className="text-base font-medium text-foreground">{title}</span>
        )}
      </div>

      <div className="flex items-center justify-center px-4 py-3">
        {breadcrumbs.length > 0 && title && (
          <span className="text-sm font-medium text-foreground">{title}</span>
        )}
      </div>

      <div className="flex items-center justify-end gap-2 py-3 pr-4">
        {actions[0]}
        {actions[1]}
      </div>
      {rightPane}
    </div>
  );
}
